// extracted by mini-css-extract-plugin
export default {"emptyComponent":"EmptyComponent_emptyComponent__jiri3"};